<template>
  <div id="wrap" v-loading="loading">
    <div class="flex flex-start flex-wrap">
      <el-form :inline="true" :model="queryParam" ref="formQuery">
        <el-form-item label="姓名：">
          <el-input
            placeholder="请输入"
            v-model="queryParam.employeeName"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门：">
          <el-select v-model="queryParam.deptName">
            <el-option
              v-for="item in depts"
              :key="item.deptName"
              :value="item.deptName"
              :label="item.deptName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间：">
          <el-date-picker
            v-model="queryParam.time"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleQuery"> 查询</el-button>

        <el-button type="primary" @click="resetQuery">重置</el-button>
      </el-form>
    </div>

    <div class="flex flex-start" style="margin-top: 15px">
      <el-button type="primary" @click="add()"> 新增</el-button>
      <el-button type="primary" @click="dialogFormVisible_daoru = true"
        >批量导入</el-button
      >
    </div>

    <div class="flex flex-justify title_box">
      <div>
        <i class="el-icon-warning" style="color: #4988df">
          已选择 <span>{{ selectLength }}</span> 项
        </i>
      </div>
      <div>
        <el-link
          type="primary"
          style="margin-left: 20px"
          :underline="false"
          @click="batchRemove"
          >删除</el-link
        >
      </div>
    </div>

    <!-- 新增考勤 -->
    <el-dialog
      title="考勤信息"
      :visible.sync="add_people_message"
      center
      width="40%"
    >
      <div class="dialog_content" @click="clickFn">
        <p class="text">基本信息</p>
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="checkingForm"
          :rules="rules"
          ref="ruleForm2"
        >
          <el-form-item label="姓名：" prop="employeeName">
            <el-input
              placeholder="请输入"
              disabled
              v-model="checkingForm.employeeName"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="工号：" prop="employeeNumber">
            <el-input
              placeholder="请输入"
              :disabled="disabled"
              v-model="checkingForm.employeeNumber"
              @blur="blurQuery"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门：" prop="deptName">
            <el-select v-model="checkingForm.deptName" disabled>
              <el-option
                v-for="item in depts"
                :key="item.deptName"
                :value="item.deptName"
                :label="item.deptName"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="项目：" prop="projectId">
            <el-select v-model="checkingForm.projectId" disabled>
              <el-option v-for="item in projectList" :label="item.projectName" :key="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <!-- <p class="text">项目</p>
        <el-form 
=======
        <p class="text">项目</p>
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="checkingForm"
          :rules="rules"
          ref="ruleForm2"
        >
        <el-form-item label="项目："  prop="projectId">
            <el-select v-model="checkingForm.projectId" disabled>
              <el-option v-for="item in projectList" :label="item.projectName" :key="item.id" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form> -->
        <p class="text">考勤信息</p>
        <el-form
          class="flex flex flex-justify flex-wrap form_box"
          label-position="top"
          :model="checkingForm"
          :rules="rules"
          ref="ruleForm1"
        >
          <el-form-item label="类型" prop="checkType">
            <el-select v-model="checkingForm.checkType">
              <el-option
                v-for="item in checkTypes"
                :label="item.label"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item label=""> </el-form-item>
          <el-form-item label="开始时间：" prop="startTime">
            <el-time-picker
              v-model="checkingForm.startTime"
              :picker-options="{
                selectableRange: `00:00:00-${
                  checkingForm.endTime
                    ? checkingForm.endTime + ':00'
                    : '23:59:59'
                }`,
              }"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item
            label="结束时间："
            prop="endTime"
            aria-placeholder="请选择"
          >
            <el-time-picker
              v-model="checkingForm.endTime"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: `${
                  checkingForm.startTime
                    ? checkingForm.startTime + ':00'
                    : '00:00:00'
                }-23:59:59`,
              }"
              placeholder="选择时间"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item
            label="考勤日期："
            prop="checkDate"
            aria-placeholder="请选择"
          >
            <el-date-picker
              v-model="checkingForm.checkDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quxiao">取消</el-button>
        <el-button type="primary" @click="saveChecking" v-loading="loading"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="dialogFormVisible_daoru"
      center
      width="44%"
    >
      <div class="dialog_content">
        <div class="download" style="margin-top: 20px; line-height: 25px">
          <div>填写需要导入的数据</div>
          <div style="color: #a3adb9">
            请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
          </div>
          <div>
            <el-link type="primary" :underline="false" @click="importTemplate"
              >下载模板</el-link
            >
          </div>
        </div>
        <div class="upload" style="margin-top: 20px; line-height: 25px">
          <div>上传填好的表格</div>
          <div style="color: #a3adb9">
            文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
          </div>
          <el-upload
            class="upload-demo"
            :action="checkingImportUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :limit="1"
            :auto-upload="false"
            :on-success="uploadSuccess"
            :on-exceed="handleExceed"
            :file-list="fileList"
            ref="upload"
          >
            <el-link type="primary" :underline="false">上传文件</el-link>
          </el-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_daoru = false">取 消</el-button>
        <el-button @click="saveUpload" type="primary">保存</el-button>
      </div>
    </el-dialog>

    <el-table
      class="table"
      :data="tableData"
      ref="checkingTable"
      @selection-change="tableSelect"
      :header-cell-style="{ background: '#F5F7FA' }"
      stripe
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection"> </el-table-column>
      <el-table-column label="姓名" prop="employeeName"></el-table-column>
      <el-table-column label="员工工号" prop="employeeNumber"></el-table-column>
      <el-table-column prop="deptName" label="部门"> </el-table-column>
      <el-table-column
        prop="checkDate"
        label="日期"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="时间"
        :formatter="timeFormat"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="时长（小时）" prop="hour"></el-table-column>
      <el-table-column label="类型" width="180" prop="checkType">
        <template slot-scope="scope">
          {{
            applicationTypeData(
              checkTypes,
              scope.row.checkType,
              "label",
              "value"
            )
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作人员" prop="createUserId"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="green"
            @click="edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            class="red"
            @click="removeChecking(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-end">
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next,total"
        :current-page.sync="queryParam.pageNum"
        :page-size.sync="queryParam.pageSize"
        :total="total"
        @current-change="search"
      >
      </el-pagination>
    </div>
    <import-tips
      :show="importOpen"
      :data="importData"
      :succeedNumber="importSucceedNumber"
      :errorNumber="importErrorNumber"
      @importOpnes="importOpnes"
    />
  </div>
</template>

<script>
import {
  getCheck,
  getDepts,
  saveChecking,
  getProjectList,
  deleteChecking,
  queryByNumber,
} from "./project";
import importTips from "./importTips.vue";
import { importDateDownloadTemplate } from "./fixedAssets";
export default {
  components: {
    importTips,
  },
  data() {
    return {
      checkingImportUrl: this.mainBaseURL + "/importDate/importChecking",
      fileList: [],
      queryParam: {
        employeeName: "",
        deptName: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10,
        projectId: "",
      },
      checkingForm: {},
      total: 0,
      depts: [],
      loading: false,
      // 导入
      dialogFormVisible_daoru: false,
      // 关联人员
      dialogFormVisible_add: false,
      // 新增
      add_people_message: false,
      checkTypes: [
        { label: "正常上班", value: 1 },
        { label: "加班", value: 2 },
        { label: "请假", value: 3 },
      ],
      radio: "1",
      input1: "",
      value1: "",
      importOpen: false,
      importData: [],
      importSucceedNumber: 0,
      importErrorNumber: 0,
      ruleForm: {
        name: "",
      },
      selectLength: 0,
      rules: {
        employeeName: [{ required: true, message: "请输入", trigger: "blur" }],
        // deptName: [{ required: true, message: "请选择", trigger: "change" }],
        // projectId: [{ required: true, message: "请选择", trigger: "change" }],
        employeeNumber: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkType: [{ required: true, message: "请选择", trigger: "change" }],
        startTime: [{ required: true, message: "请选择", trigger: "change" }],
        endTime: [{ required: true, message: "请选择", trigger: "change" }],
        checkDate: [{ required: true, message: "请选择", trigger: "change" }],
      },
      tableData: [
        {
          date: "1",
          name: "技术部",
          address: "初始规则",
          year: "无",
          batch: "1",
          founder: "何永浩",
          creationtime: "2020-10-11",
          completeness: "25%",
          state: "申请中",
        },
      ],
      projectList: [],
      value: "",
      ids: [],
      disabled: false,
      options: [
        {
          value: "1",
          label: "产品一部",
          children: [
            {
              value: "2",
              label: "研发部",
              children: [
                {
                  value: "3",
                  label: "软件",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    clickFn() {
      this.$forceUpdate();
    },
    blurQuery() {
      if (this.checkingForm.employeeNumber != "") {
        queryByNumber(this.checkingForm.employeeNumber).then((res) => {
          this.checkingForm.employeeName = res.data.employeeName;
          this.checkingForm.deptName = res.data.deptName;
        });
      }
    },
    saveUpload() {
      this.$refs.upload.submit();
      // this.dialogFormVisible_daoru = false
    },
    importTemplate() {
      importDateDownloadTemplate(11).then((res) => {
        if (res.code == "00000") {
          window.open(res.data, "_blank");
        }
      });
    },
    quxiao() {
      this.add_people_message = false;
      this.search();
    },
    edit(row) {
      this.disabled = true;
      console.log(row);
      this.checkingForm = row;
      this.add_people_message = true;
    },
    add() {
      this.disabled = false;
      this.checkingForm = {};
      // this.checkingForm.projectId=sessionStorage.getItem("zt_jjkc_project_id");
      this.add_people_message = true;
      this.$refs["ruleForm1"].clearValidate();
      this.$refs["ruleForm2"].clearValidate();
    },
    batchRemove() {
      if (this.selectLength <= 0) {
        this.$message.error("请至少选中一行");
        return;
      }
      this.$confirm("确认删除吗?", "警告", { type: "warning" }).then((ok) => {
        if (ok) {
          this.loading = true;
          this.ids = [];
          this.$refs.checkingTable.selection.forEach((item) => {
            this.ids.push(item.id);
          });
          deleteChecking(this.ids).then((res) => {
            this.loading = false;
            if (res.code == "00000") {
              this.msgSuccess("删除成功");
              this.search();
            }
          });
        }
      });
    },
    removeChecking(id) {
      this.ids = [];
      this.ids.push(id);
      this.$confirm("确认删除吗?", "警告", { type: "warning" }).then((ok) => {
        if (ok) {
          this.loading = true;
          deleteChecking(this.ids).then((res) => {
            this.loading = false;
            if (res.code == "00000") {
              this.msgSuccess("删除成功");
              this.search();
            }
          });
        }
      });
    },
    tableSelect(selection) {
      this.selectLength = selection.length;
      console.log(this.selectLength);
    },
    init() {
      this.resetQuery();
      //获取部门
      getDepts().then((res) => {
        this.depts = res.data;
      });
      //获取项目列表
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      // this.checkingForm.projectId=sessionStorage.getItem("zt_jjkc_project_id");
      // this.queryParam.projectId=sessionStorage.getItem("zt_jjkc_project_id");
    },
    // 日期选择
    timeChange(val) {
      if (val != null) {
        this.queryParam.startTime = val[0] + " 00:00:00";
        this.queryParam.endTime = val[1] + " 23:59:59";
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("formQuery");
      this.queryParam = {};
      this.handleQuery();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1;
      this.queryParam.pageSize = 10;
      this.search();
    },
    search() {
      this.loading = true;
      getCheck(this.queryParam).then((res) => {
        this.loading = false;
        this.total = res.data.total;
        this.tableData = res.data.records;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.error("超出限制文件个数");
    },
    beforeRemove(file, fileList) {},
    uploadSuccess(res, file) {
      if (res.code == "00000") {
        this.dialogFormVisible_daoru = false;
        this.$refs.upload.clearFiles();
        this.importOpen = true;
        this.importData = res.data.errorList;
        this.importSucceedNumber = res.data.succeedNumber;
        this.importErrorNumber = res.data.errorNumber;
        this.search();
      } else {
        this.$refs.upload.abort();
        this.$message.error(res.msg);
      }
    },
    importOpnes() {
      this.importOpen = false;
      this.importData = [];
      this.importSucceedNumber = 0;
      this.importErrorNumber = 0;
    },
    timeFormat(row, col) {
      return row.startTime + "至" + row.endTime;
    },
    saveChecking() {
      let result = false;
      this.$refs["ruleForm1"].validate((vaild) => {
        result = vaild;
      });
      this.$refs["ruleForm2"].validate((vaild) => {
        result = vaild;
      });
      if (result) {
        this.loading = true;
        saveChecking(this.checkingForm).then((res) => {
          this.loading = false;
          if (res.code == "00000") {
            this.msgSuccess("保存成功");
            this.add_people_message = false;
            this.search();
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.title_box {
  width: 100%;
  height: 40px;
  background-color: #e6f7ff;
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 20px 0;
}
.form_box .el-form-item {
  width: 46%;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.gsadd {
  position: absolute;
  left: 17px;
  top: 20px;
  z-index: 9;
}
</style>
